import { Component } from '@angular/core';

@Component({
  selector: 'app-homefirst-scores',
  templateUrl: './homefirst-scores.component.html',
  styleUrls: ['./homefirst-scores.component.scss'],
})
export class HomefirstScoresComponent {}
